import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import SEO from '../../../components/SEO/SEO';
import { MobileNavBar } from '../../../features/MobileNavBar';
import Navbar from '../../../horizon-layout/MainLayout/Navbar';
import { useTitleBackContext } from '../../../providers';
import { Footer } from '../../../widgets/Footer';
import { SupportConfidential } from '../../../widgets/SupportConfidential';
import { SupportContactEmail } from '../../../widgets/SupportContactEmail';
import { SupportMore } from '../../../widgets/SupportMore';
import './Support.scss';

interface MainProps {
  className?: string;
}

export const Support = ({ className }: MainProps) => {
  const { t } = useTranslation(['translation']);
  const { useTitleBack } = useTitleBackContext();

  useTitleBack(t('support.support'), null, null);

  return (
    <>
      <SEO
        title={t('pages.support.meta.title')}
        desc={t('pages.support.meta.desc')}
      />
      <div className={classNames('Support', className)}>
        <Navbar />
        <div className={classNames('Support__wrapper', className)}>
          <SupportMore />
          <SupportContactEmail />
          <SupportConfidential />
          <Footer className={'lg-max:hidden'} />
        </div>
        <MobileNavBar />
      </div>
    </>
  );
};
